import produce from "immer";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";
import getLookups from "../../views/Config/lookups";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const {
  UPDATE_PROVIDER_FORM_FIELD,
  UPDATE_PROVIDER_LIST_FILTERS,
  RESET_PROVIDER_FORM_FIELDS,
  RESET_PROVIDER_LIST_FILTERS,
  SUBMIT_PROVIDER_FORM,
  FETCH_PROVIDER_LIST,
  DELETE_PROVIDER,
  UPDATE_PROVIDER,
  FETCH_PROVIDER,
} = constants;
const { countries, providers } = getLookups();
const states = require("../../../src/views/Config/usStates.json");
const provinces = require("../../../src/views/Config/canadaProvinces.json");
const australiaStates = require("../../../src/views/Config/australiaStates.json");

const initState = {
  id: null,
  name: "",
  coplineVerified: false,
  providerType: "",
  dateVerified: "",
  email: "",
  website: "",
  address: "",
  city: "",
  state: "",
  country: { label: "United States of America", value: "USA" },
  zip: "",
  phone: "",
  hasSmsPhone: false,
  smsPhone: "",
  notes: "",
  telehealth: false,
  // async
  loading: {},
  error: {},
  success: {},
  list: [],
  tableState: {
    filtered: [],
    sorted: [],
    page: 0,
    pageSize: 100,
  },
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case UPDATE_PROVIDER_FORM_FIELD:
      return produce(state, (draft) => {
        draft[action.field] = action.value;

        if (action.field === "hasSmsPhone" && !action.value) {
          draft.smsPhone = "";
        }

        if (action.field === "coplineVerified" && !action.value) {
          draft.dateVerified = null;
        }

        draft.loading = {};
        draft.error = {};
        draft.success = {};
      });
    case UPDATE_PROVIDER_LIST_FILTERS:
      return produce(state, (draft) => {
        draft.tableState[action.field] = action.value;
      });
    case RESET_PROVIDER_FORM_FIELDS:
      const success = {
        source: RESET_PROVIDER_FORM_FIELDS,
        message: "All form fields were successfully reset.",
      };
      if (!action.payload.showMessage) {
        delete success.message;
      }
      state = {
        ...initState,
        success,
      };
      return state;

    case RESET_PROVIDER_LIST_FILTERS:
      return produce(state, (draft) => {
        draft.tableState = initState.tableState;
      });
    case SUBMIT_PROVIDER_FORM + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: action.payload.source };
      });
    case SUBMIT_PROVIDER_FORM + SUCCESS:
      return {
        ...initState,
        success: {
          source: action.payload.source,
          message: action.payload.message,
        },
      };
    case SUBMIT_PROVIDER_FORM + FAILURE:
      return produce(state, (draft) => {
        draft.error = {
          source: action.payload.source,
          message: [action.payload.message],
        };
        draft.loading = {};
        draft.success = {};
      });
    case FETCH_PROVIDER_LIST + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: action.source };
      });
    case FETCH_PROVIDER_LIST + SUCCESS:
      return produce(state, (draft) => {
        draft.success = action.payload;
        draft.loading = {};
        draft.error = {};
        draft.list = action.payload.list;
        draft.toDateFilter = state.toDateFilter;
        draft.fromDateFilter = state.fromDateFilter;
      });
    case FETCH_PROVIDER_LIST + FAILURE:
      return produce(state, (draft) => {
        draft.error = {
          source: action.payload.source,
          message: [action.payload.message],
          statusCode: action.payload.statusCode,
        };
        draft.loading = {};
        draft.success = {};
      });
    case DELETE_PROVIDER + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: action.source };
      });
    case DELETE_PROVIDER + SUCCESS:
      return produce(state, (draft) => {
        const { source, message, list, deletedProviderId } = action.payload;
        draft.success = {
          source,
          message,
        };
        draft.list = list
          ? list
          : state.list.filter((p) => p.id !== deletedProviderId);
        draft.loading = {};
        draft.error = {};
      });
    case DELETE_PROVIDER + FAILURE:
      return produce(state, (draft) => {
        draft.error = {
          source: action.payload.source,
          message: [action.payload.message],
        };
        draft.loading = {};
        draft.success = {};
      });
    case UPDATE_PROVIDER + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: UPDATE_PROVIDER };
      });
    case UPDATE_PROVIDER + SUCCESS:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = action.payload;
        draft.error = {};
      });
    case UPDATE_PROVIDER + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.error = action.payload;
        draft.success = {};
      });
    case FETCH_PROVIDER + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: FETCH_PROVIDER };
      });
    case FETCH_PROVIDER + SUCCESS:
      const {
        id,
        name,
        coplineVerified,
        providerType,
        dateVerified,
        email,
        website,
        address,
        city,
        state: provinceState,
        country,
        zip,
        phone,
        notes,
        telehealth,
        smsPhone,
      } = action.payload.provider;
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = action.payload;
        draft.error = {};
        draft.id = id;
        draft.name = name;
        draft.coplineVerified = coplineVerified;
        draft.providerType =
          providers.find((p) => p.value === providerType) || {};
        draft.dateVerified = dateVerified;
        draft.email = email;
        draft.website = website;
        draft.address = address;
        draft.city = city;
        const stateCollectionMap = { USA: states, CANADA: provinces, AUSTRALIA: australiaStates };
        const stateCollection = stateCollectionMap[country] || states;
        draft.state = stateCollection.find((s) => s.value === provinceState) || {};
        draft.country = countries.find((c) => c.value === country) || {};
        draft.zip = zip;
        draft.phone = phone;
        draft.notes = notes;
        draft.telehealth = telehealth;
        draft.hasSmsPhone = !!smsPhone;
        draft.smsPhone = smsPhone;
      });
    case FETCH_PROVIDER + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.error = action.payload;
        draft.success = {};
      });
    default:
      return state;
  }
}
